import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  // <React.StrictMode> // !caution commented out due it causing useEffect to run twice on DEV mode, per design starting from react>=18,, this will cause alot of reducent api 2nd calls
  <App />
  // </React.StrictMode>
);
